import { render, staticRenderFns } from "./XBrand.vue?vue&type=template&id=12b27536&scoped=true"
var script = {}
import style0 from "./XBrand.vue?vue&type=style&index=0&id=12b27536&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b27536",
  null
  
)

export default component.exports